import { Outlet } from 'react-router-dom';

import { CurrentUserTaskUpdatedToast } from '@sorare/gameplay/src/components/missions/CurrentUserTaskUpdatedToast';
import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

const Layout = () => {
  return (
    <AppLayout>
      <CurrentUserTaskUpdatedToast />
      <Outlet />
    </AppLayout>
  );
};

export default Layout;
